import { Card, ErrorMessage, Grid } from 'ui-toolkit/components';
import React from 'react';
import { IFetchDataState } from 'store/IFetchDataState';
import { IUnderwriterProfileData } from 'types/administration/pricing/underwriterProfileInterfaces/IUnderwriterProfile';
import { UnderwriterProfileTopLevelData } from 'components/administration/pricing/UnderwriterProfileTopLevelData';
import { UnderwriterProfileBottomLevelData } from 'components/administration/pricing/UnderwriterProfileBottomLevelData';
import { HeaderForUnderwriterProfileDetailPage } from '../../../components/administration/pricing/HeaderForUnderwriterProfileDetailPage';

export interface IUnderwriterProfileDetailPageProps {
  fetchDataState: IFetchDataState<string, IUnderwriterProfileData>;
}

export const UnderwriterProfileDetailPage: React.FC<IUnderwriterProfileDetailPageProps> = ({ fetchDataState }) => {
  const {
    data: {
      bulkRateDiscount,
      effectiveDate,
      endorsementConfig,
      otherTitleFeeConfig,
      premiumsAsTitleGuaranty,
      premiumConfig,
      refiDiscountConfig,
      simultaneousIssue,
      state,
      sunsetDate,
      underwriter,
      zone,
    },
    fetchError,
  } = fetchDataState;

  return (
    <Grid data-test-id={'underwriter-profile-detail-page'}>
      {fetchError && <ErrorMessage error={fetchError} />}
      <Card>
        <Grid>
          <HeaderForUnderwriterProfileDetailPage {...{ underwriter, state, zone, effectiveDate: '' }} />
          <UnderwriterProfileTopLevelData
            bulkRateDiscount={bulkRateDiscount}
            effectiveDate={effectiveDate}
            premiumAsTitleGuaranty={premiumsAsTitleGuaranty}
            refiDiscountConfig={refiDiscountConfig}
            sunsetDate={sunsetDate}
          />
          <UnderwriterProfileBottomLevelData
            endorsementConfig={endorsementConfig}
            otherTitleFeeConfig={otherTitleFeeConfig}
            premiumConfig={premiumConfig}
            simultaneousIssue={simultaneousIssue}
          />
        </Grid>
      </Card>
    </Grid>
  );
};
